import React from 'react'
import Tabs, {Pane} from 'scripts/lib/Tabs'
import Modal from 'react-responsive-modal'
import {FormSwitch} from 'scripts/helpers/AppHelper'
import ConsentCookie from './ConsentCookie'
import locale from 'shared/i18n/react'

const consent = new ConsentCookie()
class CookieSetting extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      setting: this.setInitial()
    }
  }

  onOpenModal = () => {
    this.setState({open: true})
  }

  onCloseModal = () => {
    this.setState({open: false})
  }

  setInitial = () => {
    return consent.GetData() || consent.SetDefault()
  }

  saveConsent = () => {
    const {open, setting} = this.state
    consent.Save(setting)
    open && this.onCloseModal()
    setTimeout(() => { window.location.reload() }, 1000)
  }

  inputChangeHandler = (e) => {
    const target = e.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    const partialSetting = this.state.setting
    this.setState({setting: Object.assign({...partialSetting}, {[name]: value})})
  }

  setPaneTitles = (item) => {
    const {type, name} = item.toggle
    const {setting} = this.state
    let Toggle = null

    switch (type) {
      case 'none': Toggle = null
        break
      case 'label': Toggle = name
        break
      case 'toggle': Toggle = <FormSwitch name={name}
        checked={setting[name]}
        handleChange={this.inputChangeHandler}
      />
    }

    return (
      <div>
        <div className={`switch-container ${type === 'label' ? 'always-on' : ''}`}>
          {Toggle}
        </div>
        <p><strong>{item.title}</strong></p>
      </div>
    )
  }

  setTabPanes = (item, index) => {
    return (
      <Pane key={index} label={item.title}>
        {this.setPaneTitles(item)}
        {item.content.map((p, i) => <p key={i}>{p}</p>)}
      </Pane>
    )
  }

  render() {
    const { open } = this.state
    const { className } = this.props
    const {whatCookie, siteFunctions, performance, socialMedia, advertising} = locale.cookieConsent.tabs
    const tabs = [
      {
        title: whatCookie.title,
        toggle: {
          type: 'none'
        },
        content: whatCookie.content
      },
      {
        title: siteFunctions.title,
        toggle: {
          type: 'label',
          name: siteFunctions.toggle
        },
        content: siteFunctions.content
      },
      {
        title: performance.title,
        toggle: {
          type: 'toggle',
          name: 'analytics'
        },
        content: performance.content
      },
      {
        title: socialMedia.title,
        toggle: {
          type: 'toggle',
          name: 'social'
        },
        content: socialMedia.content
      },
      {
        title: advertising.title,
        toggle: {
          type: 'toggle',
          name: 'advertising'
        },
        content: advertising.content
      }
    ]
    return (
      <React.Fragment>
        <a href="javascript:;" className={`${className || ''}`} onClick={this.onOpenModal}>{this.props.text}</a>
        <Modal
          open={open}
          onClose={this.onCloseModal} center
          closeOnOverlayClick={false}
          showCloseIcon={false}
          classNames={{modal: 'modal-cookie-settings'}}
        >
          <div className="cookie-setting">
            <h4>{locale.cookieConsent.title}</h4>
            <Tabs selected={0}>
              {tabs.map(this.setTabPanes)}
            </Tabs>
            <div className="cookie-settings-footer right-align">
              <a href="javascript:;" className="btn btn-pink" onClick={this.onCloseModal}>{locale.buttons.cancel}</a> <a href="javascript:;" className="btn btn-pink" onClick={this.saveConsent}>{locale.buttons.save}</a>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export default CookieSetting



// WEBPACK FOOTER //
// ./assets/js/lib/CookieSetting.jsx